// The glyph beside the autosave status line: a tick when there is nothing
// outstanding, a clock while an edit is waiting on (or in) its write, a cross
// when the write failed.
//
// Drawn rather than lettered so the three read as one set at 12px and take
// their colour from the status text they sit beside; emoji render at wildly
// different weights across platforms and would not.
export const SaveStatusIcon: React.FC<{
  kind: "ok" | "pending" | "error";
}> = ({ kind }) => {
  const color =
    kind === "ok" ? "#198754" : kind === "error" ? "#dc3545" : "#6c757d";
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 16 16"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      style={{ flexShrink: 0 }}
    >
      {kind === "ok" && <path d="M2.5 8.5 6 12l7.5-8" />}
      {kind === "error" && (
        <>
          <path d="M3.5 3.5l9 9" />
          <path d="M12.5 3.5l-9 9" />
        </>
      )}
      {kind === "pending" && (
        <>
          <circle cx="8" cy="8" r="6" />
          <path d="M8 4.5V8l2.5 1.5" />
        </>
      )}
    </svg>
  );
};
